import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils.ts'

interface SpinnerProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export function Spinner({ className, size = 'md' }: SpinnerProps) {
  return (
    <Loader2
      className={cn(
        'animate-spin text-brand-600',
        size === 'sm' && 'h-4 w-4',
        size === 'md' && 'h-5 w-5',
        size === 'lg' && 'h-7 w-7',
        className,
      )}
    />
  )
}

interface LoadingStateProps {
  label?: string
  /** Alias for label */
  message?: string
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

/**
 * Zentriertes Lade-Indikator-Element – Spinner + optionaler Text.
 */
export function LoadingState({ label, message, className, size = 'md' }: LoadingStateProps) {
  const text = label ?? message ?? 'Lade …'
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 text-gray-500',
        size === 'sm' && 'py-4',
        size === 'md' && 'py-8',
        size === 'lg' && 'py-14',
        className,
      )}
    >
      <Spinner size={size} />
      {text ? <span className="text-small">{text}</span> : null}
    </div>
  )
}

interface SkeletonProps {
  className?: string
}

export function Skeleton({ className }: SkeletonProps) {
  return <div className={cn('animate-pulse bg-gray-200 rounded', className)} />
}
